<template>
  <div class="table-responsive">
    <table class="table table-hover table-bordered table-striped" :class="{ 'collapsed': collapse, 'sticky': sticky }">
      <thead v-if="!hideColumns">
        <tr>
          <th :class="{ 'underlined': column.name === sortColumn }" scope="col" v-for="(column, iColumn) in table.columns" :key="iColumn">
            <div 
              class="text-center interactive-cursor" 
              v-if="column.sort" 
              @click="changeSort(column)">
              <span >
                {{ column.title }}
              </span>
              <i
                class="fa" 
                :class="{
                  'fa-angle-down': sortDirection.includes('DESC') || column.name !== sortColumn,
                  'fa-angle-up': sortDirection.includes('ASC')
                }" />
            </div>
            <div v-else class="text-center">
              {{ column.title }}
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <slot name="rows">
          <template v-for="(row, i) in table.rows">
            <tr :key="i">
              <template v-for="(column, iColumn) in table.columns">
                <td :key="iColumn" v-if="column.type === 'link'">
                  <template v-if="row[column.name].target">
                    <a :href="row[column.name].link" :target="row[column.name].target">
                      {{ row[column.name].label }}
                    </a>
                  </template>
                  <template v-else-if="row[column.name].link">
                    <router-link :to="{ path: row[column.name].link }">
                      {{ row[column.name].label }}
                    </router-link>
                  </template>
                  <template v-else>
                    <span>{{ row[column.name].label }}</span>
                  </template>
                </td>
                <td :key="iColumn" v-if="column.type === 'date'" :data-label="column.title">
                  {{ row[column.name].date | date_format(row[column.name].timezone) }}
                </td>
                <td :key="iColumn" v-if="column.type === 'shortDate'" :data-label="column.title">
                  {{ row[column.name] | short_date_format }}
                </td>
                <td :key="iColumn" v-if="column.type === 'text'" :data-label="column.title">
                  {{ row[column.name] }}
                </td>
                <td :key="iColumn" v-if="column.type === 'bold-text'" :data-label="column.title">
                  <strong>{{ row[column.name] }}</strong>
                </td>
                <td :key="iColumn" v-if="column.type === 'currency'" :data-label="column.title">
                  {{ row[column.name] | to_dollar_amount_neg }}
                </td>
                <td :key="iColumn" v-if="column.type === 'button'">
                  <router-link v-if="row[column.name].link" :class="`btn-${row[column.name].buttonType}`" class="btn btn-small interactive-cursor" :to="{ path: row[column.name].link }">
                    <span v-if="row[column.name].icon" :class="`fa ${row[column.name].icon} fa-fw`"></span> {{ row[column.name].buttonText }}
                  </router-link>
                  <button v-if="row[column.name].functionName" :class="`btn-${row[column.name].buttonType}`" class="btn btn-small" @click="$dispatch(row[column.name].functionName, row[column.name].functionParams)">
                    <span v-if="row[column.name].icon" :class="`fa ${row[column.name].icon} fa-fw`"></span> {{ row[column.name].buttonText }}
                  </button>
                  <span v-if="row[column.name].labelText" :class="`label-${row[column.name].labelType}`" class="label">
                    {{ row[column.name].labelText }}
                  </span>
                </td>
                <td :key="iColumn" v-if="column.type === 'label' && row[column.name].labelText">
                  <span :class="`label-${row[column.name].labelType}`" class="label">
                    {{ row[column.name].labelText }}
                  </span>
                </td>
                <td :key="iColumn" v-if="column.type === 'toggle'">
                  <div class="text-center">
                    <checkbox-input
                    :options="{ fullWidth: true }"
                    v-model="row[column.name]"
                    @input="$emit('toggle', { row, name: column.name })">
                  </checkbox-input>
                  </div>
                </td>
              </template>
            </tr>
          </template>
        </slot>
      </tbody>
    </table>
  </div>
</template>

<script>
import CheckboxInput from '@/components/inputs/CheckboxInput'

export default {
  name: 'ResponsiveTable',
  components: {
    CheckboxInput
  },
  props: {
    table: {
      type: Object,
      default () {
        return {
          title: 'Table',
          count: 0,
          columns: [
            { title: 'ID', span: 4, name: 'id' },
            { title: 'Data', span: 4, name: 'data' },
            { title: 'Status', span: 4, name: 'status' }
          ],
          rows: [
            { id: 'reservation', name: 'Data', status: '--' }
          ],
          group: false,
          groupIcon: 'map'
        }
      }
    },
    collapse: {
      type: Boolean,
      default () {
        return true
      }
    },
    sticky: {
      type: Boolean,
      default () {
        return true
      }
    },
    hideColumns: {
      type: Boolean,
      default () {
        return false
      }
    },
    defaultSort: {
      type: [String, Boolean],
      default () {
        return 'ASC'
      }
    },
    defaultSortColumn: {
      type: [String, Boolean],
      default () {
        return 'id'
      }
    }
  },
  data () {
    return {
      sortColumn: 'id',
      sortDirection: 'ASC'
    }
  },
  mounted () {
    if (this.table.columns) {
      let defaultColumn = this.table.columns.find(el => el.defaultSort)
      this.sortColumn = this.defaultSortColumn ? this.defaultSortColumn : (defaultColumn ? defaultColumn.name : '')
      this.sortDirection = this.defaultSort ? this.defaultSort : (defaultColumn ? defaultColumn.defaultDirection : '')
    }
  },
  methods: {
    changeSort (column) {
      if (this.sortColumn === column.name) {
        this.sortDirection = this.sortDirection.includes('ASC') ? 'DESC NULLS LAST' : 'ASC NULLS LAST'
      } else {
        this.sortDirection = 'ASC NULLS LAST'
      }
      this.sortColumn = column.name
      this.$emit('orderColumn', { sortDirection: this.sortDirection, ...column })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ui/ResponsiveTable.vue